import { useParams } from 'react-router-dom';
import { VerticalAdminConsole } from '@/components/dashboard/VerticalAdminConsole';

// Parameterized vertical customer admin console. Routes:
//   /admin/verticals/:vertical  (e.g. /admin/verticals/sensarra, /admin/verticals/sakme)
export function VerticalAdminPage() {
  const { vertical = '' } = useParams();
  return (
    <div className="h-full min-h-[calc(100vh-56px)] bg-[#0a0a0a] text-gray-200">
      <VerticalAdminConsole vertical={vertical} />
    </div>
  );
}
